module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-and-press-list section grid"
  }, [(!_vm.filteredArticles.length) ? _c('span', {
    staticClass: "news-and-press-list--empty-message",
    domProps: {
      "textContent": _vm._s(_vm.content.no_article_label)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid--row news-and-press--mobile-filter"
  }, [_c('div', {
    staticClass: "grid--col news-and-press--mobile-filter-col"
  }, [_c('cmp-dropdown-filter')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "news-and-press-list--articles"
  }, _vm._l((_vm.filteredArticles), function(article, articleIdx) {
    return _c('cmp-news-and-press-item', {
      key: articleIdx,
      staticClass: "news-and-press-list--article",
      attrs: {
        "article": article,
        "article-type-label": _vm.articleTypeLabel(article)
      }
    })
  })), _vm._v(" "), (_vm.showMoreBtn) ? _c('div', {
    staticClass: "news-and-press-list--more"
  }, [_c('button', {
    staticClass: "news-and-press-list--more-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onMoreRequested($event)
      }
    }
  }, [_c('span', {
    staticClass: "news-and-press-list--more-text"
  }, [_vm._v("Mehr anzeigen")]), _vm._v(" "), _c('cmp-icon', {
    staticClass: "news-and-press-list--more-icon",
    attrs: {
      "symbol": "chevron_down",
      "size": "x-small"
    }
  })], 1), _vm._v(" "), (_vm.loadError) ? _c('span', {
    staticClass: "news-and-press-list--load-error general-error",
    domProps: {
      "textContent": _vm._s(_vm.loadError)
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a08254b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a08254b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/news-and-press-list/index.vue
// module id = 574
// module chunks = 7